<!--suppress JSUnresolvedVariable, ES6CheckImport -->
<template>
  <div class="news-detail" ref="box">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-warning">
        <h1 class="animated fadeInDown">新闻中心</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>

    <div class="container content my-5">
      <!-- 当前位置 -->
      <div class="text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <router-link to="/toNewsList" class="text-muted">新闻中心</router-link>
        /
        <a href="#" class="text-muted">新闻详情</a>
      </div>

      <h2 class="text-center mt-3" style="font-size: 20px">
        {{ newsDetail.newsTitle }}
      </h2>
      <div
        class="text-center border-bottom text-secondary pb-2 mb-3 d-flex justify-content-center"
      >
        <span class="text-muted"
          >时间：
          <span class="text-danger">{{ newsDetail.publishTime }}</span>
        </span>
        <span class="text-muted ml-5"
          >访问量：
          <span class="text-info">{{ newsDetail.newsViews }}</span>
        </span>
      </div>
      <div class="content mb-3 w-100" v-html="newsDetail.newsContent"></div>
      <div class="text-secondary">
        <p>
          上一篇：
          <a
            href="#"
            type="primary"
            v-if="preNews.newsTitle !== undefined"
            @click="updateGameNewsViews(preNews.newsId)"
          >
            {{ preNews.newsTitle }}
          </a>
          <a v-else class="btn text-muted disabled">没有了</a>
        </p>
        <p>
          下一篇：
          <a
            href="#"
            type="primary"
            v-if="nextNews.newsTitle !== undefined"
            @click="updateGameNewsViews(nextNews.newsId)"
          >
            {{ nextNews.newsTitle }}
          </a>
          <a v-else class="btn text-muted disabled">没有了</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  name: "NewsDetail",
  data() {
    return {
      sectionSubTitle: "",
      backgroundUrl: "",
      logSys: 1,
      newsId: this.$route.params.newsId,
      newsDetail: {},
      preNews: {},
      nextNews: {}
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.isSystem();
    this.getNavById();
    this.getNewsDetailById();
    this.preOneNews(this.newsId, 0);
    this.nextOneNews(this.newsId, 1);
  },
  methods: {
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.logSys = 3;
      } else {
        this.logSys = 1;
      }
    },
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 3)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.backgroundUrl = resp.data.data.bannerImg;
            this.sectionSubTitle = resp.data.data.subTitle;
          }
        })
        .catch();
    },
    getNewsDetailById() {
      console.log("getNewsDetailById:", this.newsId);
      this.axios
        .get("/news/getNewsDetailById/" + this.newsId)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.newsDetail = resp.data.data;
            window.href = "#";
          }
        })
        .catch();
    },
    preOneNews(newsId, type) {
      this.axios
        .get("/news/findOneNews", {
          params: {
            newsId: newsId,
            type: type
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (resp.data.data !== null) {
              this.preNews = resp.data.data;
            }
          }
        })
        .catch();
    },
    nextOneNews(newsId, type) {
      this.axios
        .get("/news/findOneNews", {
          params: {
            newsId: newsId,
            type: type
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (resp.data.data !== null) {
              this.nextNews = resp.data.data;
            }
          }
        })
        .catch();
    },
    updateGameNewsViews(newsId) {
      console.log(newsId);
      this.axios
        .put("/news/updateGameNewsViews/" + newsId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$router
              .push({ name: "NewsDetail", params: { newsId: newsId } })
              .catch(failResponse => {
                console.log(failResponse);
              });
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.news-detail {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }

  /deep/ .content {
    @media only screen and (max-width: 576px) {
      img,
      p {
        width: 100% !important;
      }
    }
  }
}
</style>
